import React from 'react'
import { DetailReference, DetailType } from '~/types/state'

interface DetailCardTitleProps {
  reference: DetailReference<DetailType>
}

const DetailCardTitle = ({ reference }: DetailCardTitleProps): JSX.Element => {
  const { name, type } = reference

  const color = type === 'task' ? '#d9d9d9' : '#d9d9d9'

  return (
    <div className="detail-card-title">
      {name}
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
        .detail-card-title {
          height: 25px;
          border-radius: 3px;
          background: ${color};
          padding-left: 58px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          font-family: 'Inter', sans-serif;
          font-weight: bold;
          font-size: 12px;
        }
      `}</style>
    </div>
  )
}

export default DetailCardTitle
